"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var bit_javascript_default_generator_canonize_1 = require("@bit/bit.javascript.default-generator.canonize");

var bit_javascript_raw_code_generator_1 = require("@bit/bit.javascript.raw.code-generator");

exports.mainFile = 'index.vue';

function makeTemplate(_a) {
  var _b;

  var npmId = _a.npmId;
  var code = generateVueDefaultCode({
    npmId: npmId
  });
  return {
    files: (_b = {}, _b[exports.mainFile] = code, _b),
    mainFile: exports.mainFile
  };
}

exports.makeTemplate = makeTemplate;
var codeGenerator = new bit_javascript_raw_code_generator_1.CodeGenerator();

function generateVueDefaultCode(_a) {
  var npmId = _a.npmId;
  var moduleName = bit_javascript_default_generator_canonize_1.toCanonicalClassName(npmId);
  var moduleId = bit_javascript_default_generator_canonize_1.canonizeNpmId(npmId);
  var vueTemplate = generateVueTemplate({
    moduleName: moduleName
  });
  var vueModule = generateVueModule({
    moduleName: moduleName,
    moduleId: moduleId
  }).split('\n').map(function (x) {
    return "\t" + x;
  }).join('\n');
  var vueStyle = generateVueStyle();
  return ["" + vueTemplate, "", "<script>", "" + vueModule, "</script>", "", "" + vueStyle].join('\n');
}

exports.generateVueDefaultCode = generateVueDefaultCode;

function generateVueTemplate(_a) {
  var moduleName = _a.moduleName;
  return ["<template>", "\t<" + moduleName + " />", "</template>"].join('\n');
}

function generateVueModule(_a) {
  var moduleId = _a.moduleId,
      moduleName = _a.moduleName;
  var imports = [{
    defaultName: moduleName,
    moduleId: moduleId
  }];
  var defaultExport = ["{", "\tdata () {", "\t\treturn {", "\t\t\tvar1: 'World'", "\t\t}", "\t},", "\tcomponents: {", "\t\t" + moduleName, "\t}", "}"].join('\n');
  return codeGenerator.generateModule({
    imports: imports,
    defaultExport: defaultExport
  });
}

function generateVueStyle() {
  return ["<style scoped>", "", "</style>"].join('\n');
}